export const NavigatorType = {
  Browser: 'browser',
  Hash: 'hash',
  Memory: 'memory'
};
